<script>
    import { capitalizeFirstLetter } from "@/utils";
    import LookbookTemplateOne from "@xd/components/LookbookTemplateOne";
    import LookbookTemplateTwo from "@xd/components/LookbookTemplateTwo";
    import LookbookTemplateThree from "@xd/components/LookbookTemplateThree";
    import LookbookTemplateFour from "@xd/components/LookbookTemplateFour";

    export default {
        name: "LookbookTemplate",
        components: {
            LookbookTemplateOne,
            LookbookTemplateTwo,
            LookbookTemplateThree,
            LookbookTemplateFour,
        },
        props: {
            products: Array,
            productId: String,
            offerId: String,
            name: String,
            dot: Object,
            type: {
                type: String,
                validator: (v) => {
                    return ["one", "two", "three", "four"].includes(v);
                },
            },
        },
        data() {
            return {
                visibleElements: [],
            };
        },
        computed: {
            componentName() {
                return "LookbookTemplate" + capitalizeFirstLetter(this.type);
            },
            product() {
                return this.products.find((product) => String(product.id) === this.productId);
            },
        },
        mounted() {
            this.$nextTick(() => {
                this.startAnimation();
            });
        },
        methods: {
            startAnimation() {
                const elements = this.$refs.template.$el.querySelectorAll("[data-name]");

                const options = {
                    root: null,
                    rootMargin: "0px",
                    threshold: 0.15,
                };

                const observer = new IntersectionObserver((entries, observer) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            const { name } = entry.target.dataset;
                            this.visibleElements.push(name);
                            observer.unobserve(entry.target);
                        }
                    });
                }, options);

                elements.forEach((element) => observer.observe(element));
            },
        },
    };
</script>

<template>
    <component
        :is="componentName"
        :name="name"
        :offerId="offerId"
        :product="product"
        :dot="dot"
        :visible-elements="visibleElements"
        ref="template"
    ></component>
</template>

<style lang="scss">
    .lookbook-template {
        padding: 24px 0;
        @include bp($bp-desktop-sm) {
            padding: 44px 0;
        }
    }

    .lookbook-template__inner {
        @include bp($bp-desktop-sm) {
            display: flex;
            flex-wrap: wrap;
        }
    }

    .lookbook-template__image {
        position: relative;
        &::before {
            content: "";
            display: block;
        }
        &.image-full-width {
            &::before {
                padding-bottom: 55.55%;
            }
        }
        &.image-square {
            &::before {
                padding-bottom: 100%;
            }
        }
        &.image-rect {
            &::before {
                padding-bottom: 48.03%;
            }
        }

        @include bp($bp-desktop-sm) {
            &.image-full-width {
                flex-basis: 100%;
                max-width: 100%;
            }
            &.image-square {
                flex-basis: 396px;
                flex-shrink: 0;
                max-width: 396px;
            }
            &.image-rect {
                flex-grow: 1;
            }
        }
    }
</style>
